<label class="form-label omgui-checkbox-container" [class.disabled]="disabled">
  <input
    type="checkbox"
    [id]="inputId"
    [attr.name]="name"
    [attr.value]="value"
    [disabled]="disabled"
    [(ngModel)]="_checked"
    (ngModelChange)="handleChange($event)"
    (blur)="handleTouched()"
    [attr.aria-label]="ariaLabel ? ariaLabel : label ? label.trim() : 'Checkbox'"
    [attr.aria-checked]="_checked"
    role="checkbox"
  /><span class="omgui-checkbox-checkmark"> </span>
  <span *ngIf="label && label.trim()" [class.label-with-subtitle]="subtitle">
    {{ label.trim() }}
  </span>
  <div *ngIf="subtitle" class="label-subtitle">{{ subtitle }}</div>
</label>
